import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { Badge } from "@shared/ui/badge";
import React from "react";
import { useParams } from "react-router-dom";

const RecipientListDetails: React.FC<{ data: any }> = ({ data }) => {
  const { id, name } = useParams();
  const recipientListDetails = [
    {
      label: "Segment",
      value: data?.segmentName || "N/A",
    },
    {
      label: "List Type",
      value: data?.filterTypeDisplay || "N/A",
    },
    {
      label: "Audience",
      value: data?.audienceTypeDisplay || "N/A",
    },
  ];
  const creationDetails = [
    {
      label: "Created By",
      value: data?.createdUserRemoteName || "N/A",
    },
    {
      label: "Created On",
      value: data?.createdDate || "N/A",
    },
    {
      label: "Updated By",
      value: data?.lastModifiedUserRemoteName || "N/A",
    },
    {
      label: "Last Updated",
      value: data?.lastModifiedDate || "N/A",
    },
  ];
  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-md font-semibold">{name}</h2>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant={data?.isActive ? "success" : "destructive"}>
            {data?.isActive ? "Active" : "Inactive"}
          </Badge>
          <Badge variant="outline">{data?.filterTypeDisplay}</Badge>
        </div>
      </div>
      {data?.tags.map((tag: any) => (
        <Badge variant="secondary" className="mr-2">{tag}</Badge>
      ))}
      <div className="mt-4">
        <div className="border-b-2 border-gray-200"></div>
      </div>
      <div className="mt-4">
        <h3 className="text-sm font-semibold text-foreground">List Details</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-x-12 gap-y-4 mt-3">
        {recipientListDetails.map((item) => (
          <ValueLabel key={item.label} label={item.label} value={item.value} />
        ))}
      </div>
      <div className="mt-4">
        <div className="border-b-2 border-gray-200"></div>
      </div>
      <div className="mt-4">
        <h3 className="text-sm font-semibold text-foreground">
          Creation Details
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-x-12 gap-y-4 mt-3">
        {creationDetails.map((item) => (
          <ValueLabel key={item.label} label={item.label} value={item.value} />
        ))}
      </div>
    </div>
  );
};

export default RecipientListDetails;
